module.exports = __webpack_public_path__ + "assets/8281ab6276c0c7d2e95c197063526187.png";